import '../errors.styles';

import initPage from '@/scripts/init/init';
import initPrimaryLayout from '@/layouts/primary/primary-layout';

initPage();
initPrimaryLayout();